import React, { createContext, useContext } from 'react';
import { useAuth } from '../../../context/AuthContext';

const MentorContext = createContext(null);

export function MentorProvider({ children }) {
  const { user } = useAuth();
  const mentors = user ? [{ _id: user._id, name: user.name, email: user.email }] : [];

  return <MentorContext.Provider value={{ mentors }}>{children}</MentorContext.Provider>;
}

export function useMentor() {
  const ctx = useContext(MentorContext);
  if (!ctx) throw new Error('useMentor must be used within MentorProvider');
  return ctx;
}
